type props = {
  color?: string
}

const QuestionsSVG = ({ color, ...props }: props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width={30}
    height={30}
    x={0}
    y={0}
    viewBox="210 300 898 588"
    style={{
      // @ts-expect-error: [TYPE_TEMP_FIX] not sure if enableBackground is existing in CSS styling
      enableBackground: 'new 0 0 512 512',
    }}
    xmlSpace="preserve"
    className=""
    {...props}
  >
    <g
      fill="none"
      stroke="#F6A237"
      stroke-width="47"
      stroke-linecap="round"
      stroke-linejoin="round"
    >
      <path d="M350 176H696c51 0 94 42 94 94v218c0 51-42 94-94 94H439L272 686l32-95c-39-15-64-52-64-94V270c0-52 42-94 94-94Z" />
      <path d="M843 422h155c51 0 94 42 94 94v219c0 42-26 79-65 94l32 95-167-95H658c-52 0-94-42-94-94v-75" />
      <path d="M837 561h91" />
      <path d="M778 632h150" />
      <path d="M696 707h148" />
    </g>
    <g
      fill="none"
      stroke={color || '#F6A237'}
      stroke-width="47"
      stroke-linecap="round"
      stroke-linejoin="round"
    >
      <path d="M449 320c4-43 42-60 74-54 38 7 60 36 50 70-7 25-30 40-47 53-15 12-25 24-25 37" />
      <path d="M508 489h1" />
    </g>
  </svg>
)
export default QuestionsSVG
